//Hien thi ban do theo format react
import React from "react";
import {unByKey} from 'ol/Observable';
import ol_Overlay from 'ol/Overlay';
import ol_source_XYZ from "ol/source/XYZ";
import ol_source_Vector from "ol/source/Vector";
import ol_geom_Point from "ol/geom/Point";
import ol_geom_LineString from "ol/geom/LineString";
import ol_geom_Polygon from "ol/geom/Polygon";
import ol_geom_Circle from "ol/geom/Circle";
import ol_Feature from "ol/Feature";
import ol_style_Stroke from 'ol/style/Stroke';
import { transform as ol_proj_transform } from "ol/proj";
import { toStringHDMS } from "ol/coordinate";
import Link from "@material-ui/core/Link";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DropzoneArea } from "material-ui-dropzone";
import DateTimePicker from "react-datetime";
import SelectFilter from "react-select";
import ThoiTietEditDialog from "./danhmuc/ThoiTietEditDialog";
import SquareSearchEditDialog from "./SquareSearchEditDialog";
import ParallelSearchEditDialog from "./ParallelSearchEditDialog";
import SectorSearchEditDialog from './SectorSearchEditDialog';
import SuKienChiTietOverlay from './SuKienChiTietOverlay';

import Map from "../geo/map.jsx";
import MyButton from "../pages/MyButton";

import {
  interaction,
  layer,
  custom,
  control, //name spaces
  Interactions,
  Overlays,
  Controls, //group
  Layers,
  Overlay,
  Util, //objects
} from "../geo/index";
import "./mapview.css";
import SuKienLayer from "./SuKienLayer";
import localConfig from "local-storage";
import { Draw } from "ol/interaction";
import DrawLayer from "./DrawLayer.jsx";
import DrawItemsLayer from "./DrawItemsLayer";
import KhuVucLayer from "./KhuVucLayer";
import { PlayCircleFilledWhite } from "@material-ui/icons";
import PointEditDialog from "./PointEditDialog";
import LineEditDialog from "./LineEditDialog";
import PolygonEditDialog from "./PolygonEditDialog";
import CircleEditDialog from "./CircleEditDialog";
import FilterSuKienDialog from "./FilterSuKienDialog";
import SuKienEditdialog from "./SuKienEditDialog";
import SarTrackLayer from './SarTrackLayer';

const DrawLayerUtil = require("./DrawLayerUtil");
const myLib = require("../lib/MyLib");
const server = require("../lib/server");

const styles = {
  mapview: {
    height: "100%",
    width: "100%",
    //width: 600,
  },
  drawingItemText: {
    backgroundColor: "#ffcc33ee",
    color: "black",
    border: "1px solid white",
    fontSize: 13,
  },
  drawItemText: {
    position: "relative",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: "4px",
    color: "white",
    padding: "4px 8px",
    opacity: "0.7",
    whiteSpace: "nowrap",
    backgroundColor: "#ffcc33",
    color: "white",
    border: "1px solid white",
    borderTop: "6px solid rgba(0, 0, 0, 0.5)",
    borderRight: "6px solid transparent",
    borderLeft: "6px solid transparent",
    content: '""',
    position: "absolute",
    bottom: "-6px",
    marginLeft: "-7px",
    left: "50%",
  },
  khuvucItemText: {
    backgroundColor: "#ffcc33",
    color: "red",
    fontSize: 13,
    textAlign: "center",
  },
};
//Hien thi cac doi tuong tren ban do
class MapViewControl extends React.Component {
  constructor(props) {
    super(props);
    this.showPopup = this.showPopup.bind(this);
    this.createMeasureTooltip = this.createMeasureTooltip.bind(this);
    this.map_onDrawstart = this.map_onDrawstart.bind(this);
    this.map_onDrawend = this.map_onDrawend.bind(this);
    this.map_onMoveend = this.map_onMoveend.bind(this);
    this.map_onPointermove = this.map_onPointermove.bind(this);
    this.handleSaveDrawItem = this.handleSaveDrawItem.bind(this);
    this.showTauSar = this.showTauSar.bind(this);
    var center_string = localConfig.get("map_center");
    var zoom_string = localConfig.get("map_zoom");
    this.state = {
      sukien_olLayer: undefined, //layer OL hien thi su kien
      //cac thong so lien quan den map
      center: center_string ? JSON.parse(center_string) : [106, 20],
      zoom: zoom_string ? parseInt(zoom_string) : 7,
      drawingType: undefined,
      mouseCoordinate: undefined, //vi tri chuot khi dnag ve
      drawSourceVector: new ol_source_Vector({ wrapX: false }),
      timeChange: new Date(),
      showPointEdit: false, //hine thi dialog edit point
      showLineEdit: false,
      showSquareSearch: false, //show square search
      showParallelSearch: false,
      showSectorSearch: false,
      showPolygonEdit: false,
      showCircleEdit: false,
      edittingMode: "edit",
      Editting_Feature: undefined, //feature dang edit
      //cac drawitems
      drawItems: [], //danh sach feature da co trong csdl
      khuvucItems: [], //danh sach feature khu vuc
      //show menu ban do
      bando_menu_anchor: null, //vi tri hien thi ban do
      bando_google_layer: localConfig.get("bando")
        ? localConfig.get("bando")
        : "m", //lua chon layer de hien thi
      show_layer_hinhve:
        localConfig.get("show_hinhve") !== undefined
          ? localConfig.get("show_hinhve") === true
          : true,
      show_layer_khuvuc:
        localConfig.get("show_khuvuc") !== undefined
          ? localConfig.get("show_khuvuc") === true
          : false,
      show_overlay_hinhve:localConfig.get("show_overlay_hinhve") !== undefined
          ? localConfig.get("show_overlay_hinhve") === true
          : false,
      //hien thi filter su kien dialog
      show_filter_dialog: false,
      sukien_filter_result: [], //danh sach features hien thi cho su kien
      sukien_filter_data: {
        TrangThai: "1",
        LoaiTau_TauHang: true,
        LoaiTau_TauCa: true,
        LoaiTau_TauKhac: true,
        TuNgay: null,
        DenNgay: null,
      }, //tieu chi tim kiem
      open_edit_sukien: false, //hien thi form chi tiet su kien
      Editting_MaSK: 0,
      //hien thi thong tin khu vuc
      showThoiTiet: false,
      Editting_MaKV: 0,
      links_menu_anchor: undefined, // hien thi menu
      links: [],
      //overlays hien thi thong tin su kien
      listChitiets: [], 
      //hien thi luoi toa do
      showGraticule: localConfig.get('showGraticule') !== undefined ? localConfig.get('showGraticule') : false,
      //hien thi hanh trinh tau sar
      trackSars: [], //du lieu hanh trinh tau sar
    };
    this.state.drawSourceVector.on("change", (event) => {
      this.setState({
        timeChange: new Date(),
        drawSourceVector: this.state.drawSourceVector,
      }); //phai co dong code nay thi overlay moi lam viec
    });
  }
  overlayComp = undefined;
  popupComp = undefined;
  sukienLayer = undefined;
  showPopup1(evt) {
    this.overlayComp.overlay.setPosition(evt.coordinate);
    var lonlat = ol_proj_transform(evt.coordinate, "EPSG:3857", "EPSG:4326");
    this.popupComp.setContents(
      `<p>You clicked here:</p><code> ${lonlat[0]}, ${lonlat[1]}</code>`
    );
    this.popupComp.show();
  }
  showPopup(feature) {
    var coord = feature.getGeometry().getCoordinates();
    this.overlayComp.overlay.setPosition(coord);
    var lonlat = coord;
    this.popupComp.setContents(
      `<p>Thông tin về tàu hoặc phương tiện tham gia TKCN`
    );
    this.popupComp.show();
  }
  getSelectedFeatureStyle() {
    return new custom.style.MarkerStyle(
      "https://openlayers.org/en/latest/examples/data/icon.png"
    ).style;
  }
  map_onMoveend = (event) => {
    var center = event.frameState.viewState.center;
    var zoom = event.frameState.viewState.zoom;
    //save center, zoom for later
    localConfig.set("map_center", JSON.stringify(center));
    localConfig.set("map_zoom", zoom + "");
  };
  map_onPointermove = (event) => {
    if (event.dragging) {
      return;
    }
    if(this.state.drawingType) {
      
    }
  };
  createMeasureTooltip = () => {
    if (this.measureTooltipElement) {
      this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
    }
    this.measureTooltipElement = document.createElement('div');
    this.measureTooltipElement.className = 'tooltip tooltip-measure';
    this.measureTooltip = new ol_Overlay({
      element: this.measureTooltipElement,
      offset: [0, -15],
      positioning: 'bottom-center',
    });
    this.mapComp.map.addOverlay(this.measureTooltip);
  }
  map_onDrawstart = (evt) => {
    // set sketch
    var sketch = evt.feature;
    this.createMeasureTooltip(); //tao tooltip    
    /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
    var tooltipCoord = evt.coordinate;
    var that = this;
    this.listener = sketch.getGeometry().on('change', function (evt) {
      var geom = evt.target;
      var tooltipCoord = 0;
      tooltipCoord = geom.getLastCoordinate();
      var output = '';
      if(that.state.drawingType === 'LineString') {
        output = myLib.getLineStringLength(sketch);
      }
      else if(that.state.drawingType === 'Polygon') {
        tooltipCoord = geom.getInteriorPoint().getCoordinates();
        output = myLib.getPolygonArea(sketch);
      }
      else if(that.state.drawingType === 'Circle') {
        tooltipCoord = geom.getCenter();
        output = myLib.getRadius(sketch);
      }
      that.measureTooltipElement.innerHTML = output;
      that.measureTooltip.setPosition(tooltipCoord);
    });
  }
  map_onDrawend = (event) => {
    //console.log(event.feature.getGeometry() + '');
    console.log("draw end");
    event.feature.set("type", this.state.drawingType);
    //neu la polygon, circle thi add them cac center
    if (this.state.drawingType === "Circlexxxxxx") {
      var center = event.feature.getGeometry().getCenter();
      var center_feature = new ol_Feature({
        geometry: new ol_geom_Point(center),
        type: "Point",
        fake: true,
        reference: event.feature, //tham chieu de sau nay remove
      });
      event.feature.set('center_feature', center_feature);
      this.state.drawSourceVector.addFeature(
        center_feature
      );
    }
    this.setState({ drawingType: undefined }); //ket thuc drawing
    unByKey(this.listener);
    this.measureTooltip.setPosition(undefined); //an di tooltip
  };
  //hien thi tau sar tren ban do
  showTauSar = (feature) => {
    var data = feature.get('data');
    server.query('sukien/getdieudong?mask=' + data.MaSK).then((response) => {
      var tracks = this.state.trackSars;
      tracks[data.MaSK] = response;
      this.setState({trackSars: tracks});
    }).catch((error) => console.log(error));
  }
  //load hinh ve de hien thi
  loadDrawItems() {
    //thuc hien query ve server va hien thi
    server
      .query("hinhve/gettimkiem")
      .then((response) => {
        var list = [];
        response.map((item, index) => {
          item.id = index + 1;
          var json = JSON.parse(item.JsonData);
          item.JsonData = json;
          list.push(
            new ol_Feature({
              geometry:
                item.Loai === "Point"
                  ? new ol_geom_Point(json.Coordinates[0])
                  : item.Loai === "LineString" ||
                    item.Loai === "SquareSearch" ||
                    item.Loai === "ParallelSearch" ||
                    item.Loai === "SectorSearch"
                  ? new ol_geom_LineString(json.Coordinates)
                  : item.Loai === "Polygon"
                  ? new ol_geom_Polygon([json.Coordinates])
                  : item.Loai === "Circle"
                  ? new ol_geom_Circle(
                      json.Coordinates[0],
                      json.BanKinh / (1852 * 60)
                    )
                  : null,
              type: item.Loai,
              saved: true, //danh dau feature da co trong csdl
              data: item, //du lieu dang luu trong csdl
            })
          );
          if (item.Loai === "Circlexxxxxxxxx") {
            //add them point of center fake
            list.push(
              new ol_Feature({
                geometry: new ol_geom_Point(json.Coordinates[0]),
                type: "Point",
                fake: true,
              })
            );
          }
        });
        this.setState({ drawItems: list });
      })
      .catch((error) => console.log(error));
  }
  //load va hien thi lien ket
  loadLinks() {
    //thuc hien query ve server va hien thi
    server
      .get("/links.json")
      .then((response) => {
        console.log(response);
        this.setState({links: response});
      })
      .catch((error) => console.log(error));
  }
  //load hinh ve de hien thi
  loadKhuVucItems() {
    //thuc hien query ve server va hien thi
    server
      .query("khuvuc/gethinhve")
      .then((response) => {
        var list = [];
        response.map((item, index) => {
          item.id = index + 1;
          list.push(
            new ol_Feature({
              geometry: new ol_geom_Polygon([item.Coordinates]),
              type: "Polygon",
              saved: true, //danh dau feature da co trong csdl
              data: item, //du lieu dang luu trong csdl
            })
          );
        });
        this.setState({ khuvucItems: list });
      })
      .catch((error) => console.log(error));
  }
  loadDanhmuc() {}
  componentDidMount() {
    this.loadDanhmuc();
    this.loadDrawItems();
    this.loadKhuVucItems();
    this.loadSuKien();
    this.loadLinks();
  }
  handleSaveDrawItem = (feature, action) => {
    var newData = feature.get("data");
    var items = this.state.drawItems;
    var index = -1;
    items.map((old, i) => {
      var data = old.get("data");
      if (data && newData && data.ID === newData.ID) {
        index = i;
      }
    });
    if (action !== "xoa") {
      if (index < 0) {
        items.push(feature);
        this.state.drawSourceVector.removeFeature(feature);
      }
    } else {
      if (this.state.drawSourceVector.hasFeature(feature)) {
        if(feature.get('center_feature') !== undefined) { //circle co center feature
          this.state.drawSourceVector.removeFeature(feature.get('center_feature'));  
        }
        this.state.drawSourceVector.removeFeature(feature);
      }
      if (index >= 0) {
        items.splice(index, 1);
      }
    }
    this.setState({
      drawItems: items,
      drawSourceVector: this.state.drawSourceVector,
    });
  };
  changeMapType(type) {
    this.setState({ bando_menu_anchor: null, bando_google_layer: type });
    localConfig.set("bando", type); //cau hinh cho phien lam viec tiep theo
  }
  loadSuKien() {
    server
      .post("sukien/filter", this.state.sukien_filter_data)
      .then((response) => {
        this.handleFilterResult(this.state.sukien_filter_data, response);
      })
      .catch((error) => console.log(error));
  }

  //Xu ly ket qua tim kiem su kien
  handleFilterResult(filter, result) {
    //tao lap danh sach features
    const list = [];
    const danhsach = result.danhsach;
    danhsach.map((item, index) => {
      list.push(
        new ol_Feature({
          geometry: new ol_geom_Point([item.Lon, item.Lat]),
          name: item.TenSK,
          type: "sukien",
          data: item, //thong tin data
        })
      );
    });
    this.setState({
      show_filter_dialog: false,
      sukien_filter_data: filter,
      sukien_filter_result: list,
      listChitiets: [], //clear hien thi chi tiet
      trackSars: [],
    });
  }
  render() {
    const markers = [];
    if (global.mapHeight === undefined) {
      global.mapHeight = this.props.height;
    }
    return (
      <>
        <div>
          <MyButton
            text="Lọc sự vụ"
            onClick={(event) => this.setState({ show_filter_dialog: true })}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.show_layer_khuvuc}
                onChange={(event) => {
                  this.setState({ show_layer_khuvuc: event.target.checked });
                  localConfig.set("show_khuvuc", event.target.checked);
                }}
                name="chkKhuvuc"
              />
            }
            label="Khu vực biển"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.show_layer_hinhve}
                onChange={(event) => {
                  this.setState({ show_layer_hinhve: event.target.checked });
                  localConfig.set("show_hinhve", event.target.checked);
                }}
                name="chkHinhve"
              />
            }
            label="Hình vẽ"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.show_overlay_hinhve}
                onChange={(event) => {
                  this.setState({ show_overlay_hinhve: event.target.checked });
                  localConfig.set("show_overlay_hinhve", event.target.checked);
                }}
                name="chkHinhve"
              />
            }
            label="Tên hình vẽ"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.showGraticule}
                onChange={(event) => {
                  this.setState({ showGraticule: event.target.checked });
                  localConfig.set("showGraticule", event.target.checked);
                }}
                name="chkHinhve"
              />
            }
            label="Lưới tọa độ"
          />
          <MyButton
            text="Bản đồ"
            onClick={(event) =>
              this.setState({ bando_menu_anchor: event.currentTarget })
            }
          />
          <Menu
            id="simple-menu"
            anchorEl={this.state.bando_menu_anchor}
            keepMounted
            open={Boolean(this.state.bando_menu_anchor)}
            onClose={() => this.setState({ bando_menu_anchor: null })}
          >
            <MenuItem onClick={() => this.changeMapType("m")}>
              Google Road
            </MenuItem>
            <MenuItem onClick={() => this.changeMapType("y")}>
              Google Satellite
            </MenuItem>
            <MenuItem onClick={() => this.changeMapType("p")}>
              Google Terrain
            </MenuItem>
            <MenuItem onClick={() => this.changeMapType("viet")}>
              Việt Nam
            </MenuItem>            
          </Menu>
          <MyButton
            text="Vẽ đa giác"
            onClick={() => this.setState({ drawingType: "Polygon" })}
          />
          <MyButton
            text="Vẽ điểm"
            onClick={() => this.setState({ drawingType: "Point" })}
          />
          <MyButton
            text="Vẽ đoạn"
            onClick={() => this.setState({ drawingType: "LineString" })}
          />
          <MyButton
            text="Vẽ tròn"
            onClick={() => this.setState({ drawingType: "Circle" })}
          />
          <MyButton
            text="Website"
            onClick={(event) =>
              this.setState({ links_menu_anchor: event.currentTarget })
            }
          />
          <Menu
            id="simple-menu"
            anchorEl={this.state.links_menu_anchor}
            open={Boolean(this.state.links_menu_anchor)}
            onClose={() => this.setState({ links_menu_anchor: null })}
          >
            {this.state.links.map((item, index) => {
              return (
                <MenuItem onClick={() => window.open(item.url, "_blank")}>
                  {item.name}
                </MenuItem>
              );
            })}
          </Menu>
        </div>
        <Map
          view={{
            projection: "EPSG:4326",
            center: this.state.center,
            zoom: this.state.zoom,
          }}
          style={{
            ...styles.mapview,
            height1: global.mapHeight ? global.mapHeight : 500,
          }}
          onMoveend={this.map_onMoveend}
          ref={(el) => (this.mapComp = el)}
          onPointermove={this.map_onPointermove}
        >
          <Layers>
            {/*Ban do nen */}
            {this.state.bando_google_layer === "m" ? (
              <layer.Tile
                source={
                  new ol_source_XYZ({
                    url:
                      "https://mt1.google.com/vt/lyrs=m&hl=vi&x={x}&y={y}&z={z}",
                    crossOrigin: "Anonymous",
                  })
                }
              />
            ) : null}
            {this.state.showGraticule ? (
              <layer.Graticule
                strokeStyle={
                  new ol_style_Stroke({
                    color: "rgba(0,0,0,0.9)",
                    width: 1,
                    lineDash: [1, 4],
                  })
                }
                showLabels={true}
                wrapX={false}
              />
            ) : null}
            {this.state.bando_google_layer === "s" ? (
              <layer.Tile
                source={
                  new ol_source_XYZ({
                    url:
                      "https://mt1.google.com/vt/lyrs=s&hl=vi&x={x}&y={y}&z={z}",
                    crossOrigin: "Anonymous",
                  })
                }
              />
            ) : null}
            {this.state.bando_google_layer === "y" ? (
              <layer.Tile
                source={
                  new ol_source_XYZ({
                    url:
                      "https://mt1.google.com/vt/lyrs=y&hl=vi&x={x}&y={y}&z={z}",
                    crossOrigin: "Anonymous",
                  })
                }
              />
            ) : null}
            {this.state.bando_google_layer === "p" ? (
              <layer.Tile
                source={
                  new ol_source_XYZ({
                    url:
                      "https://mt1.google.com/vt/lyrs=p&hl=vi&x={x}&y={y}&z={z}",
                    crossOrigin: "Anonymous",
                  })
                }
              />
            ) : null}
            {this.state.bando_google_layer === "viet" ? (
              <layer.Tile
                source={
                  new ol_source_XYZ({
                    url: server.getServer() + '/Map.ashx?' + 'x={x}&y={y}&z={z}',
                    crossOrigin: "Anonymous",
                  })
                }
              />
            ) : null}
            {/* Su kien layer */}
            {
              <SuKienLayer
                features={this.state.sukien_filter_result}
                ref={(el) => (this.sukienLayer = el)}
              />
            }
            {/* draw layer */}
            {/*<layer.Vector source={this.state.drawSourceVector} style={DrawLayerUtil.drawStyleFunction} />*/}
            <DrawLayer source={this.state.drawSourceVector}></DrawLayer>
            {/**Layer hien thi cac draw item da co trong csdl */}
            {this.state.show_layer_hinhve ? (
              <DrawItemsLayer features={this.state.drawItems} />
            ) : null}
            {/**Hien thi layer khu vuc */}
            {this.state.show_layer_khuvuc ? (
              <KhuVucLayer features={this.state.khuvucItems} />
            ) : null}
            {/**Hien thi layer hanh trinh tau sar */}
            <SarTrackLayer tracks={this.state.trackSars} />
          </Layers>
          <Overlays>
            <Overlay ref={(item) => (this.overlayComp = item)}>
              <custom.Popup
                ref={(item) => (this.popupComp = item)}
              ></custom.Popup>
            </Overlay>
            {/**Hien thi overlay khi dang drawing */}
            {this.state.drawingType ? (
              <Overlay
                position={this.state.mouseCoordinate}
                offset={[0, -15]}
                positioning="bottom-center"
              >
                <div className="tooltip tooltip-measure"></div>
              </Overlay>
            ) : null}
            {/**Hien thi overlay cho cac item draw */}
            {this.state.drawSourceVector.getFeatures().map((feature, index) => {
              const type = feature.get("type");
              const fake = feature.get("fake");
              if (true === fake) {
                return undefined;
              }
              const coord =
                type === "Point"
                  ? feature.getGeometry().getCoordinates()
                  : type === "LineString" ||
                    type === "SquareSearch" ||
                    type === "ParallelSearch" ||
                    type === "SectorSearch"
                  ? feature.getGeometry().getLastCoordinate()
                  : type === "Polygon"
                  ? feature.getGeometry().getInteriorPoint().getCoordinates()
                  : feature.getGeometry().getCenter();
              return (
                <Overlay
                  key={"D" + index}
                  position={coord}
                  offset={[0, -15]}
                  positioning="bottom-center"
                >
                  <div className="tooltip tooltip-measure">
                    <Link
                      href="#"
                      onClick={() => {
                        if (type === "Point") {
                          this.setState({
                            showPointEdit: true,
                            edittingMode: "edit",
                            Editting_Feature: feature,
                          });
                        }
                        if (type === "LineString") {
                          this.setState({
                            showLineEdit: true,
                            edittingMode: "edit",
                            Editting_Feature: feature,
                          });
                        }
                        if (type === "Polygon") {
                          this.setState({
                            showPolygonEdit: true,
                            edittingMode: "edit",
                            Editting_Feature: feature,
                          });
                        }
                        if (type === "Circle") {
                          this.setState({
                            showCircleEdit: true,
                            edittingMode: "edit",
                            Editting_Feature: feature,
                          });
                        }
                      }}
                      variant="body2"
                    >
                      <pre>
                        {type === "Point"
                          ? myLib.latToDMS(coord[1]) +
                            "-" +
                            myLib.lonToDMS(coord[0])
                          : type === "LineString"
                          ? myLib.getLineStringLength(feature)
                          : type === "Circle"
                          ? myLib.getRadius(feature) +
                            "\n" +
                            myLib.latToDMS(coord[1]) +
                            "-" +
                            myLib.lonToDMS(coord[0])
                          : myLib.getPolygonArea(feature)}
                      </pre>
                    </Link>
                    {type === "LineString" ? (
                      <>
                        <Link
                          href="#"
                          onClick={() => {
                            if (type === "LineString") {
                              this.setState({
                                showSquareSearch: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                          }}
                          variant="body2"
                        >
                          <pre>Square search</pre>
                        </Link>
                        <Link
                          href="#"
                          onClick={() => {
                            if (type === "LineString") {
                              this.setState({
                                showParallelSearch: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                          }}
                          variant="body2"
                        >
                          <pre>Parallel search</pre>
                        </Link>
                        <Link
                          href="#"
                          onClick={() => {
                            if (type === "LineString") {
                              this.setState({
                                showSectorSearch: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                          }}
                          variant="body2"
                        >
                          <pre>Sector search</pre>
                        </Link>
                      </>
                    ) : null}
                  </div>
                </Overlay>
              );
            })}
            {/**Hien thi overlay cho cac item da co trong CSDL */}
            {this.state.show_layer_hinhve && this.state.show_overlay_hinhve
              ? this.state.drawItems.map((feature, index) => {
                  const type = feature.get("type");
                  const fake = feature.get("fake");
                  const data = feature.get("data");
                  if (true === fake) {
                    return undefined;
                  }
                  const coord =
                    type === "Point"
                      ? feature.getGeometry().getCoordinates()
                      : type === "LineString" ||
                        type === "SquareSearch" ||
                        type === "ParallelSearch" ||
                        type === "SectorSearch"
                      ? feature.getGeometry().getLastCoordinate()
                      : type === "Polygon"
                      ? feature
                          .getGeometry()
                          .getInteriorPoint()
                          .getCoordinates()
                      : feature.getGeometry().getCenter();
                  return (
                    <Overlay
                      key={"D" + index}
                      keyID={"D" + index}
                      position={coord}
                      offset={[0, -15]}
                      positioning="bottom-center"
                    >
                      <div className="tooltip tooltip-measure">
                        <Link
                          href="#"
                          onClick={() => {
                            if (type === "Point") {
                              this.setState({
                                showPointEdit: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                            if (type === "LineString") {
                              this.setState({
                                showLineEdit: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                            if (type === "SquareSearch") {
                              this.setState({
                                showSquareSearch: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                            if (type === "ParallelSearch") {
                              this.setState({
                                showParallelSearch: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                            if (type === "SectorSearch") {
                              this.setState({
                                showSectorSearch: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                            if (type === "Polygon") {
                              this.setState({
                                showPolygonEdit: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                            if (type === "Circle") {
                              this.setState({
                                showCircleEdit: true,
                                edittingMode: "edit",
                                Editting_Feature: feature,
                              });
                            }
                          }}
                          variant="body2"
                        >
                          <div>{data.Ten}</div>
                          <div></div>
                          {type === "Point"
                            ? myLib.latToDMS(coord[1]) +
                              "-" +
                              myLib.lonToDMS(coord[0])
                            : type === "LineString" ||
                              type === "SquareSearch" ||
                              type === "ParallelSearch" ||
                              type === "SectorSearch"
                            ? myLib.getLineStringLength(feature)
                            : type === "Circle"
                            ? myLib.getRadius(feature)
                            : myLib.getPolygonArea(feature)}
                        </Link>
                      </div>
                    </Overlay>
                  );
                })
              : null}
            {/**Hien thi overlay cho cac khu vuc da ve trong csdl */}
            {this.state.show_layer_khuvuc && this.state.show_overlay_hinhve
              ? this.state.khuvucItems.map((feature, index) => {
                  const type = "Polygon";
                  const fake = false;
                  const data = feature.get("data");
                  if (true === fake) {
                    return undefined;
                  }
                  const coord = feature
                    .getGeometry()
                    .getInteriorPoint()
                    .getCoordinates();
                  return (
                    <Overlay
                      key={"D" + index}
                      keyID={"D" + index}
                      position={coord}
                      offset={[0, -15]}
                      positioning="bottom-center"
                    >
                      <div className="tooltip tooltip-measure">
                        <Link
                          href="#"
                          onClick={() => {
                            this.setState({
                              showThoiTiet: true,
                              Editting_MaKV: data.MaKV,
                            });
                          }}
                          variant="body2"
                        >
                          <pre>
                            {data.TenKhuVuc + "\n(" + data.MaVung.label + ")"}
                          </pre>
                        </Link>
                      </div>
                    </Overlay>
                  );
                })
              : null}

            {/**Hien thi chi tiet su kien */}
            {this.state.listChitiets.map((feature, index) => {
              const data = feature.get("data");
              const coord = feature.getGeometry().getCoordinates();
              return (
                <Overlay
                  key={"C" + index}
                  keyID={"C" + index}
                  position={coord}
                  offset={[0, -48]}
                  positioning="bottom-center"
                >
                  <SuKienChiTietOverlay
                    feature={feature}
                    callback={(action) => {
                      if (action === "chitiet") {
                        this.setState({
                          open_edit_sukien: true,
                          Editting_MaSK: data.MaSK,
                        });
                      }
                      if (action === "close") {
                        var found = undefined;
                        var list = this.state.listChitiets;
                        list.map((item, index) => {
                          if (item.get("data").MaSK === data.MaSK) {
                            found = index;
                          }
                        });
                        if (found >= 0) {
                          list.splice(found, 1);
                          this.setState({ listChitiets: list });
                        }
                      }
                      if(action === 'sar') { //hien thi tau sar cua su kien
                        this.showTauSar(feature);
                      }
                    }}
                  />
                </Overlay>
              );
            })}
          </Overlays>
          <Controls attribution={false} zoom={true}>
            <control.Rotate />
            <control.ScaleLine />
            <control.FullScreen />
            <control.ZoomSlider />
            <control.ZoomToExtent />
            <control.Zoom />
            <control.MousePosition coordinateFormat={toStringHDMS} />
          </Controls>
          <Interactions>
            <interaction.Select
              style={null}
              filter={(feature, layer) => {
                if (feature.get("type") === "sukien") {
                  return true;
                }
                return false;
              }}
              onSelect={(evt) => {
                evt.selected.forEach((feature) => {
                  //hien thi thong tin su kien
                  const data = feature.get("data");
                  const list = this.state.listChitiets;
                  var found = false;
                  list.map((item,index) => {
                    found = found || item.get('data').MaSK === data.MaSK;
                  })
                  if(!found) {
                    list.push(feature);
                    this.setState({ listChitiets: list });
                  }
                  /*
                  this.setState({
                    open_edit_sukien: true,
                    Editting_MaSK: data.MaSK,
                  });
                  * */
                });
              }}
            />
            {this.state.drawingType ? (
              <interaction.Draw
                onDrawstart={this.map_onDrawstart}
                onDrawend={this.map_onDrawend}
                source={this.state.drawSourceVector}
                type={this.state.drawingType}
              />
            ) : undefined}
          </Interactions>
        </Map>
        {this.state.showPointEdit && global.User.Quyen.R211 ? (
          <PointEditDialog
            value={this.state.Editting_Feature}
            visible={true}
            fullWidth={true}
            maxWidth={"sm"}
            EditMode={this.state.edittingMode}
            onClose={(result) =>
              this.setState(
                {
                  showPointEdit: false,
                  edittingMode: "edit",
                },
                () => {}
              )
            }
            onSaved={this.handleSaveDrawItem}
          />
        ) : null}
        {this.state.showLineEdit && global.User.Quyen.R211 ? (
          <LineEditDialog
            value={this.state.Editting_Feature}
            visible={true}
            fullWidth={true}
            maxWidth={"sm"}
            EditMode={this.state.edittingMode}
            onClose={(result) =>
              this.setState(
                {
                  showLineEdit: false,
                  edittingMode: "edit",
                },
                () => {}
              )
            }
            onSaved={this.handleSaveDrawItem}
          />
        ) : null}
        {this.state.showPolygonEdit && global.User.Quyen.R211 ? (
          <PolygonEditDialog
            value={this.state.Editting_Feature}
            visible={true}
            fullWidth={true}
            maxWidth={"sm"}
            EditMode={this.state.edittingMode}
            onClose={(result) =>
              this.setState(
                {
                  showPolygonEdit: false,
                  edittingMode: "edit",
                },
                () => {}
              )
            }
            onSaved={this.handleSaveDrawItem}
          />
        ) : null}
        {this.state.showCircleEdit && global.User.Quyen.R211 ? (
          <CircleEditDialog
            value={this.state.Editting_Feature}
            visible={true}
            fullWidth={true}
            maxWidth={"sm"}
            EditMode={this.state.edittingMode}
            onClose={(result) =>
              this.setState(
                {
                  showCircleEdit: false,
                  edittingMode: "edit",
                },
                () => {}
              )
            }
            onSaved={this.handleSaveDrawItem}
          />
        ) : null}
        {this.state.show_filter_dialog ? (
          <FilterSuKienDialog
            visible={this.state.show_filter_dialog}
            fullWidth={true}
            maxWidth={"md"}
            value={this.state.sukien_filter_data}
            callback={(ok) => this.setState({ show_filter_dialog: ok })}
            onSearched={(filter, result) => {
              this.handleFilterResult(filter, result);
            }}
          />
        ) : null}
        {this.state.open_edit_sukien ? (
          <SuKienEditdialog
            visible={this.state.open_edit_sukien}
            fullWidth={true}
            maxWidth={"xl"}
            MaSK={this.state.Editting_MaSK}
            EditMode={"edit"}
            onClose={() =>
              this.setState({
                open_edit_sukien: false,
                Editting_MaSK: undefined,
              })
            }
          />
        ) : null}
        {this.state.showThoiTiet ? (
          <ThoiTietEditDialog
            visible={this.state.showThoiTiet}
            fullWidth={true}
            maxWidth={"sm"}
            MaKV={this.state.Editting_MaKV}
            EditMode={this.state.showConfirmXoa ? "xoa" : "edit"}
            onClose={(result) =>
              this.setState(
                {
                  showThoiTiet: false,
                  Editting_MaKV: undefined,
                  showConfirmXoa: false,
                },
                () => {}
              )
            }
          />
        ) : null}
        {this.state.showSquareSearch && global.User.Quyen.R211 ? (
          <SquareSearchEditDialog
            visible={this.state.showSquareSearch}
            value={this.state.Editting_Feature}
            fullWidth={true}
            maxWidth={"md"}
            EditMode={this.state.edittingMode}
            onClose={(result) =>
              this.setState(
                {
                  showSquareSearch: false,
                  edittingMode: "edit",
                },
                () => {}
              )
            }
            onSaved={this.handleSaveDrawItem}
          />
        ) : null}
        {this.state.showSectorSearch && global.User.Quyen.R211 ? (
          <SectorSearchEditDialog
            visible={this.state.showSectorSearch}
            value={this.state.Editting_Feature}
            fullWidth={true}
            maxWidth={"md"}
            EditMode={this.state.edittingMode}
            onClose={(result) =>
              this.setState(
                {
                  showSectorSearch: false,
                  edittingMode: "edit",
                },
                () => {}
              )
            }
            onSaved={this.handleSaveDrawItem}
          />
        ) : null}
        {this.state.showParallelSearch && global.User.Quyen.R211 ? (
          <ParallelSearchEditDialog
            visible={this.state.showParallelSearch}
            value={this.state.Editting_Feature}
            fullWidth={true}
            maxWidth={"md"}
            EditMode={this.state.edittingMode}
            onClose={(result) =>
              this.setState(
                {
                  showParallelSearch: false,
                  edittingMode: "edit",
                },
                () => {}
              )
            }
            onSaved={this.handleSaveDrawItem}
          />
        ) : null}
      </>
    );
  }
}
export default MapViewControl;
